// extracted by mini-css-extract-plugin
export default {"ratingRoot":"ratingRoot__48CDj","item":"item__978WX","md":"md__dUJCl","webOption":"webOption__j30Hn","active":"active__oNIQP"};